import { useMemo } from "react";
import { actionSummary, calendarLeadRow, groupSteps, visibleActionSteps } from "./actionSteps";

// Derives the Action card's header summary and grouped timeline rows from the
// suggestion's steps. For scheduled work (payment plan, promise to pay) the internal
// check-if-paid and calendar-scheduling steps are hidden and a display-only
// "Schedule … in calendar" lead row is prepended. Memoized on the
// steps/explanation/type identity since grouping re-walks the full step list.
export default function useActionTimeline(steps, explanation, type, kind) {
  return useMemo(() => {
    const visible = visibleActionSteps(steps, type);
    const groups = groupSteps(visible);
    const lead = calendarLeadRow(type, groups, kind);
    return {
      summary: actionSummary(visible, explanation),
      groups: lead ? [lead, ...groups] : groups,
    };
  }, [steps, explanation, type, kind]);
}
